import type { AppMode } from './PricingContextProvider';

const isPreviewPrice = (appMode: AppMode) => appMode !== 'DEFAULT';

export { isPreviewPrice };
